<template>
    <div>
        <button @click.prevent="$parent.show" class="btn btn-outline-primary btn-sm pull-right" ref="button">
            {{$t('global.Filter')}}
        </button>

        <transition mode="out-in" name="slide">
            <div class="table-filter-panel" v-closable="{
                  exclude: ['button'],
                  handler: 'hide'
                }" v-if="this.$parent.showFilter">
                <legend>Advanced Search</legend>
                <form @submit.prevent="$emit('onColumnFilter')">
                    <div class="filter-input-group">
                        <label>Component</label>
                        <input class="form-control" placeholder="e.g. 123" v-model="filterForm.number" />
                    </div>
                    <div class="filter-input-group">
                        <label>Customer</label>
                        <input class="form-control" v-model="filterForm.name" />
                    </div>
                    <div class="filter-input-group">
                        <label>Date</label>
                        <VueCtkDateTimePicker
                                :custom-shortcuts="[
                                                  { key: 'Today', label: 'Today', value: 'day' },
                                                  { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
                                                  { key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
                                                  { key: 'last7Days', label: 'Last 7 days', value: 7 },
                                                  { key: 'last30Days', label: 'Last 30 days', value: 30 },
                                                  { key: 'thisMonth', label: 'This month', value: 'month' },
                                                  { key: 'lastMonth', label: 'Last month', value: '-month' },
                                                  { key: 'thisYear', label: 'This year', value: 'year' },
                                                  { key: 'lastYear', label: 'Last year', value: '-year' }
                                                ]" :no-label="true"
                                :only-date="true" :range="true"
                                format="YYYY-MM-DD"
                                formatted="DD/MM/YYYY"
                                id="control_date"
                                label="Control"
                                name="control_date" v-model="date_control"
                                v-validate="'required'"
                        ></VueCtkDateTimePicker>
                    </div>
                    <div class="filter-input-group">
                        <label>Type</label>
                        <input class="form-control" v-model="filterForm.type_name" />
                    </div>
                    <div class="filter-input-group">
                        <label>Approved</label>
                        <div class="custom-control custom-switch">
                            <input class="custom-control-input" id="customSwitch1" type="checkbox">
                            <label class="custom-control-label" for="customSwitch1"></label>
                        </div>
                    </div>
                    <div class="filter-input-group">
                        <button @click="$emit('onColumnFilter')" class="btn btn-block btn-primary">
                            <div v-if="!isLoading">
                                <span>Search</span>
                            </div>
                            <div v-else>
                                            <span aria-hidden="true" class="spinner-border spinner-border-sm"
                                                  role="status"></span>
                                Loading...
                            </div>
                        </button>
                        <button @click="$emit('hide')" class="btn btn-block btn-outline-primary">Close</button>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>
<script>
    import Vue from 'vue'

    let handleOutsideClick
    Vue.directive('closable', {
        bind(el, binding, vnode) {
            handleOutsideClick = (e) => {
                e.stopPropagation()
                const {handler, exclude} = binding.value
                let clickedOnExcludedEl = false
                exclude.forEach(refName => {
                    if (!clickedOnExcludedEl) {
                        const excludedEl = vnode.context.$refs[refName]
                        clickedOnExcludedEl = excludedEl.contains(e.target)
                    }
                })
                if (!el.contains(e.target) && !clickedOnExcludedEl) {
                    vnode.context[handler]()
                }
            }
            document.addEventListener('click', handleOutsideClick)
            document.addEventListener('touchstart', handleOutsideClick)
        },

        unbind() {
            document.removeEventListener('click', handleOutsideClick)
            document.removeEventListener('touchstart', handleOutsideClick)
        }
    })

    export default {
        data() {
            return {
                date_control: ''
            }
        },
        props: ['filterForm', 'isLoading'],
        methods: {
            hide() {
                this.$parent.hide()
            }
        },
        watch: {
            date_control: function () {
                this.filterForm.control_date = [
                    this.date_control.start,
                    this.date_control.end
                ]
            }
        }
    }
</script>
<style>
    .flex-direction-column {
        left: -100px !important;
    }
</style>
